import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalculatorAutosComponent } from './calculator-autos.component';
import { CalculatorRoutingAutosModule } from './calculator-routing.module';
import { RequestsSharedModule } from '../@shared';
import { RequestAutosStore } from '../@shared/request-data-autos/request-data-autos.store';

@NgModule({
  declarations: [CalculatorAutosComponent],
  imports: [CommonModule, CalculatorRoutingAutosModule, RequestsSharedModule],
  providers: [RequestAutosStore],
})
export class CalculatorAutosModule {}
